// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fc95cb9b","879":"4e91e8ef"}[chunkId] + ".chunk.js";
};